export default "__VITE_ASSET__Bz1$59Ka__"